import imgKuntotarkastus from "url:./images/kuntotarkastus_nega.png";
import imgKuntotarkastus2x from "url:./images/kuntotarkastus_nega@2x.png";
import imgIlmatiiveysmittaus from "url:./images/tiiveysmittaus_nega.png";
import imgIlmatiiveysmittaus2x from "url:./images/tiiveysmittaus_nega@2x.png";
import imgKosteusmittaus from "url:./images/kosteusmittaus_nega.png";
import imgKosteusmittaus2x from "url:./images/kosteusmittaus_nega@2x.png";
import imgLampokuvaus from "url:./images/lampokuvaus_nega.png";
import imgLampokuvaus2x from "url:./images/lampokuvaus_nega@2x.png";
import imgIlmanvaihdonhuolto from "url:./images/ilmanvaihdonhuolto_nega.png";
import imgIlmanvaihdonhuolto2x from "url:./images/ilmanvaihdonhuolto_nega@2x.png";
import imgKaikkiPalvelut from "url:./images/kaikkipalvelut.png";
import imgKaikkiPalvelut2x from "url:./images/kaikkipalvelut@2x.png";
import imgPekka from "url:./images/pekka.jpg";

import imgTarjouspyyntojenPortaali from "url:./images/tarjouspyyntojen-portaali.png";

import imgMitenToimii1 from "url:./images/miten-toimii-1.png";
import imgMitenToimii2 from "url:./images/miten-toimii-2.png";
import imgMitenToimii3 from "url:./images/miten-toimii-3.png";
import imgMitenToimii4 from "url:./images/miten-toimii-4.png";

import imgOstoskori from "url:./images/ostoskori.png";
import imgCheckGreen from "url:./images/check-green.png";
import imgHETSite from "url:./images/het-site.png";
import imgFacebookIcon from "url:./images/facebook-icon.png";

setImages("img_kuntotarkastus", imgKuntotarkastus, "65w", imgKuntotarkastus2x, "130w", "50vw");
setImages("img_kuntotarkastus2", imgKuntotarkastus, "65w", imgKuntotarkastus2x, "130w", "50vw");
setImages("img_ilmatiiveysmittaus", imgIlmatiiveysmittaus, "65w", imgIlmatiiveysmittaus2x, "130w", "50vw");
setImages("img_ilmatiiveysmittaus2", imgIlmatiiveysmittaus, "65w", imgIlmatiiveysmittaus2x, "130w", "50vw");
setImages("img_kosteusmittaus", imgKosteusmittaus, "65w", imgKosteusmittaus2x, "130w", "50vw");
setImages("img_kosteusmittaus2", imgKosteusmittaus, "65w", imgKosteusmittaus2x, "130w", "50vw");
setImages("img_lampokuvaus", imgLampokuvaus, "65w", imgLampokuvaus2x, "130w", "50vw");
setImages("img_lampokuvaus2", imgLampokuvaus, "65w", imgLampokuvaus2x, "130w", "50vw");
setImages("img_ilmanvaihdonhuolto", imgIlmanvaihdonhuolto, "65w", imgIlmanvaihdonhuolto2x, "130w", "50vw");
setImages("img_ilmanvaihdonhuolto2", imgIlmanvaihdonhuolto, "65w", imgIlmanvaihdonhuolto2x, "130w", "50vw");
setImages("img_kaikkipalvelut", imgKaikkiPalvelut, "43w", imgKaikkiPalvelut2x, "86w", "50vw");
setImages("img_kaikkipalvelut2", imgKaikkiPalvelut, "43w", imgKaikkiPalvelut2x, "86w", "50vw");


setImage("img_pekka", imgPekka);


setImage("img_tarjouspyyntojenportaali", imgTarjouspyyntojenPortaali);
setImage("img_mitentoimii1", imgMitenToimii1);
setImage("img_mitentoimii2", imgMitenToimii2);
setImage("img_mitentoimii3", imgMitenToimii3);
setImage("img_mitentoimii4", imgMitenToimii4);

setImage("img_ostoskori1", imgOstoskori);
setImage("img_ostoskori2", imgOstoskori);
setImage("img_ostoskori3", imgOstoskori);
setImage("img_ostoskori4", imgOstoskori);
setImage("img_ostoskori5", imgOstoskori);

setImage("img_checkgreen1", imgCheckGreen);
setImage("img_checkgreen2", imgCheckGreen);
setImage("img_checkgreen3", imgCheckGreen);
setImage("img_checkgreen4", imgCheckGreen);
setImage("img_checkgreen5", imgCheckGreen);

setImage("img_hetsite", imgHETSite);
setImage("img_facebookicon", imgFacebookIcon);

function setImage(elementId, imgSrc){
    let img  = document.getElementById(elementId); 
    if(img) img.src=imgSrc;
}

function setImages(elementId, imgSrc1, imgSrc1w, imgSrc2, imgSrc2w, sizes){
    let img  = document.getElementById(elementId); 
    if(img){
        img.srcset = imgSrc1 + ' ' + imgSrc1w + ', ' + imgSrc2 + ' ' + imgSrc2w;
        img.sizes = sizes;
    }
}